import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_DIALOG_STIL } from './fiko-dialog-stil';

/** CATIA Spline Definition (GSD wireframe) — sıralı nokta listesinden pürüzsüz eğri. */
@Component({
  selector: 'fikoyt-spline-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Spline Noktaları (sıralı)</div>
      @for(idx of refler(); track $index){
        <div class="sd-row"><label>{{ $index + 1 }}.</label>
          <select [ngModel]="idx" (ngModelChange)="degistir($index, $event)">
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select>
          <button class="sd-pick" (click)="kaldir($index)" title="Kaldır">✕</button>
        </div>
      }
      @if(!refler().length){ <div class="sd-bos">Önce noktalar oluştur, sonra ekle.</div> }
      <button class="sd-btn sd-sec" (click)="ekle3d()">🎯 3D'den Nokta Ekle</button>
      <button class="sd-btn sd-sec" (click)="ardisik3d()">✏️ Yüze / 3D'ye Ardışık Çiz (sağ-tık bitir)</button>
      <button class="sd-btn" (click)="tumNoktalar()">⊕ Tüm Noktaları Al</button>
    </div>
    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoSplineDialog {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  refler(): number[] { return this.element?.refler || []; }
  noktalar(): any[] { return this.yonetici?.noktaSecenekleri?.(this.element) || []; }
  guncelle(): void { this.yonetici?.padGuncelle(this.element, 'refler', [...(this.element.refler || [])]); this.CD.markForCheck(); }
  degistir(i: number, v: any): void { const arr = [...(this.element.refler || [])]; arr[i] = +v; this.element.refler = arr; this.guncelle(); }
  kaldir(i: number): void { const arr = [...(this.element.refler || [])]; arr.splice(i, 1); this.element.refler = arr; this.guncelle(); }
  ekle3d(): void { this.yonetici?.refSecListeBaslat?.(this.element, 'refler', ['nokta3d'], () => this.CD.markForCheck()); }
  ardisik3d(): void { this.yonetici?.splineArdisik3dBaslat?.(this.element, () => this.CD.markForCheck()); }
  tumNoktalar(): void { this.element.refler = this.noktalar().map((o: any) => o.deger); this.guncelle(); }
  private kapat(): void { this.yonetici?.refSecBitir?.(); (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
